export interface Review {
  quote: string
  name: string
  location: string
  job: string
  rating: number
  source: 'Google' | 'Facebook' | 'Nextdoor'
  date: string
  verified: boolean
  reply?: string
}

export const ratingSummary = {
  average: '5.0',
  count: '187',
  rehire: '9 out of 10',
}

export const reviews: Review[] = [
  {
    quote:
      "We got three quotes and A&J was the only one who got in the pool and showed me what was actually wrong with the shell. The number Jose gave me in the driveway is the number I paid — no change orders, nothing. Four weeks later it looks better than the day we bought the house.",
    name: 'Marisol R.',
    location: 'Katy, TX',
    job: 'Replaster + waterline tile',
    rating: 5,
    source: 'Google',
    date: 'August 2026',
    verified: true,
    reply: 'Thank you Marisol! Tell Danny the spa jets are still on us. — A&J',
  },
  {
    quote:
      "Crew was here at 7:30 every morning they said they'd be here. My last contractor ghosted me for two weeks in the middle of a demo, so honestly that punctuality is what I'm reviewing. Work came out great too.",
    name: 'Dale W.',
    location: 'Cypress, TX',
    job: 'Full backyard remodel',
    rating: 5,
    source: 'Google',
    date: 'June 2026',
    verified: true,
  },
  {
    quote:
      "The prep is where they're different. They chipped out everything the cheap guy left behind instead of plastering over it like the other bid wanted to. Three summers later, zero cracks, color still even.",
    name: 'Anthony G.',
    location: 'Spring, TX',
    job: 'Replaster',
    rating: 5,
    source: 'Facebook',
    date: 'May 2026',
    verified: true,
  },
  {
    quote:
      "Asked for license and insurance and had the paperwork in my inbox that afternoon. No excuses, no 'I'll get it to you.' Hired them again the next year for my mom's pool in Spring Branch.",
    name: 'Karen B.',
    location: 'Houston, TX',
    job: 'Coping + tile',
    rating: 5,
    source: 'Google',
    date: 'April 2026',
    verified: true,
  },
  {
    quote:
      "Only reason it's not a longer review is there's nothing to complain about. Coping line is dead straight, tile is cleaner than the original builder's, and they hauled off every bit of debris.",
    name: 'Rick A.',
    location: 'Sugar Land, TX',
    job: 'Coping replacement',
    rating: 5,
    source: 'Nextdoor',
    date: 'March 2026',
    verified: true,
  },
  {
    quote:
      "Weather pushed us back about four days and they called me each time instead of leaving me guessing. Small thing, but after what we went through with the last company it meant a lot. Pool is gorgeous.",
    name: 'Tanya M.',
    location: 'Richmond, TX',
    job: 'Replaster + LED lights',
    rating: 5,
    source: 'Google',
    date: 'February 2026',
    verified: true,
  },
  {
    quote:
      "Quoted $9,400, paid $9,400. Took about three and a half weeks with the fill and cure. My neighbor already booked them after seeing ours.",
    name: 'Brandon L.',
    location: 'Tomball, TX',
    job: 'Replaster',
    rating: 5,
    source: 'Google',
    date: 'January 2026',
    verified: true,
  },
  {
    quote:
      "They were honest that our shell only needed a patch and a recolor, not the full rebuild another company tried to sell us. Saved us around six thousand dollars. That's who I'm calling from now on.",
    name: 'Elena V.',
    location: 'Pearland, TX',
    job: 'Patch + recolor',
    rating: 5,
    source: 'Facebook',
    date: 'November 2025',
    verified: true,
  },
  {
    quote:
      "Second pool we've had them do. First one was our house in Cypress in 2021, this one was the rental. Same crew, same quality, and they still pick up the phone on the first try.",
    name: 'Greg P.',
    location: 'Cypress, TX',
    job: 'Replaster (repeat customer)',
    rating: 5,
    source: 'Google',
    date: 'September 2026',
    verified: true,
    reply: 'Always good working with you Greg — thanks for the trust. — A&J',
  },
  {
    quote:
      "I'm picky and I watched every step. They water-tested, they cleaned the bond beam, they didn't rush the cure. Tile lines are straight as a ruler. Worth every dollar.",
    name: 'Nadia S.',
    location: 'The Woodlands, TX',
    job: 'Replaster + spa tile',
    rating: 5,
    source: 'Google',
    date: 'July 2026',
    verified: true,
  },
  {
    quote:
      "Got a quote from a guy who couldn't show me a license. A&J emailed theirs with the estimate. Ended up costing about the same and I actually slept at night.",
    name: 'Luis O.',
    location: 'Missouri City, TX',
    job: 'Coping + plaster',
    rating: 5,
    source: 'Google',
    date: 'May 2026',
    verified: true,
  },
  {
    quote:
      "Our pool had been green for two years and I was embarrassed to have people over. Three weeks later we hosted my daughter's graduation party in that backyard. Thank you all.",
    name: 'Denise H.',
    location: 'Humble, TX',
    job: 'Restoration + tile',
    rating: 5,
    source: 'Google',
    date: 'April 2026',
    verified: true,
  },
]
